import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointNodeGroupDhcpProps {
  onSubmit: () => void;
  endpointNodeGroup: string;
  endpointDhcpEnabled: boolean;
  endpointDhcp?: string;
}
export const EndpointNodeGroupDhcp = ({
  onSubmit,
  endpointNodeGroup,
  endpointDhcpEnabled = false,
  endpointDhcp,
}: EndpointNodeGroupDhcpProps) => {
  const api = useApi();
  const [enabled, setEnabled] = React.useState(endpointDhcpEnabled);
  const [ip, setIp] = React.useState(endpointDhcp);

  const enDhcpPost = useMutation(api.configureDhcpRelayApiV1ConfigureDhcpRelayPost, {
    onSuccess() {
      toast.success('Endpoint group DHCP configuration updated successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    enDhcpPost.mutate({
      node_group_id: endpointNodeGroup,
      enabled,
      server_ip: ip,
    });
  };

  return (
    <Box pt={2}>
      <FormControlLabel
        control={<Checkbox checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />}
        label="Enable DHCP Relay"
        sx={{ mb: 4 }}
      />

      <TextField
        fullWidth
        label="DHCP Server IP"
        variant="outlined"
        value={ip}
        onChange={(e) => setIp(e.target.value)}
        placeholder="DHCP Server IP, example: 192.168.67.5"
        disabled={!enabled}
        autoFocus
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};
